module.exports = __webpack_public_path__ + "static/media/ArrowDropdown.33e7c61c.svg";